import { Grid, LinearProgress, Typography } from "@material-ui/core";
import { useDataProvider } from "react-admin";
import React, { useEffect, useState } from "react";
import { filter } from "lodash";
import SanitizedGrid from "../../../components/SanitizedGrid";
import { GridinRow, GridLabel } from "utils/style";
import AssignmentLinkField from "./AssignmentLinkField";

interface IBusDataListField {
  studentId: number;
}

const getRouteNames = (type: string, data: IRouteData[]) => {
  let routeNames: string[] = [];
  switch (type) {
    case "to_school":
      const filteredDataAM = filter(data, { routeType: "to_school" });

      filteredDataAM.map((data: any) => {
        routeNames = [...routeNames, ...data.routeNames];
      });

      return routeNames;
    case "from_school":
      const filteredDataPM = filter(data, { routeType: "from_school" });

      filteredDataPM.map((data: any) => {
        routeNames = [...routeNames, ...data.routeNames];
      });

      return routeNames;
    case "cca":
      const filteredDataCCA = filter(data, { routeType: "cca" });

      filteredDataCCA.map((data: any) => {
        routeNames = [...routeNames, ...data.routeNames];
      });

      return routeNames;
    default:
      return [];
  }
};

const BusDataListField = ({ studentId }: IBusDataListField) => {
  const [routeData, setRouteData] = useState<IRouteData[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const provider = useDataProvider();

  useEffect(() => {
    setIsLoading(true);
    provider
      .customGetOne(`students/${studentId}/routeNames`)
      .then(({ data }: any) => {
        setRouteData(data as IRouteData[]);
        setIsLoading(false);
      })
      .catch((e: any) => {
        setIsLoading(false);
      });
  }, []);

  const amRouteNames = getRouteNames("to_school", routeData);
  const pmRouteNames = getRouteNames("from_school", routeData);
  const ccaRouteNames = getRouteNames("cca", routeData);

  return (
    <SanitizedGrid container spacing={2}>
      {isLoading ? (
        <Grid item xs={12}>
          <LinearProgress />
        </Grid>
      ) : (
        <>
          <Grid item xs={12} style={GridinRow}>
            <Typography variant="body2" style={GridLabel}>
              AM :
            </Typography>
            <Typography variant="body2">
              {amRouteNames.length > 0
                ? amRouteNames.map((routeName: string, index: number) => (
                    <AssignmentLinkField
                      routeName={routeName}
                      isLastIteration={amRouteNames.length === index + 1}
                    />
                  ))
                : "-"}
            </Typography>
          </Grid>
          <Grid item xs={12} style={GridinRow}>
            <Typography variant="body2" style={GridLabel}>
              PM :
            </Typography>
            <Typography variant="body2">
              {pmRouteNames.length > 0
                ? pmRouteNames.map((routeName: string, index: number) => (
                    <AssignmentLinkField
                      routeName={routeName}
                      isLastIteration={pmRouteNames.length === index + 1}
                    />
                  ))
                : "-"}
            </Typography>
          </Grid>
          <Grid item xs={12} style={GridinRow}>
            <Typography variant="body2" style={GridLabel}>
              CCA :
            </Typography>
            <Typography variant="body2">
              {ccaRouteNames.length > 0
                ? ccaRouteNames.map((routeName: string, index: number) => (
                    <AssignmentLinkField
                      routeName={routeName}
                      isLastIteration={ccaRouteNames.length === index + 1}
                    />
                  ))
                : "-"}
            </Typography>
          </Grid>
        </>
      )}
    </SanitizedGrid>
  );
};

export default BusDataListField;
